import * as React from "react";
import type { SVGProps } from "react";
const SvgCostaRica = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1280 720"
    {...props}
  >
    <defs>
      <radialGradient
        id="Costa_Rica_svg__radial-gradient"
        cx={-24538.31}
        cy={-12541.78}
        r={16.02}
        gradientTransform="matrix(.13 0 0 -.13 3504.78 -1153.26)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fbd55f" />
        <stop offset={1} stopColor="#cb8e32" />
      </radialGradient>
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-2"
        cx={-24505.1}
        cy={-12549.69}
        r={10.79}
        gradientTransform="matrix(.13 0 0 -.13 3504.78 -1153.14)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-3"
        cx={-24538.23}
        cy={-12355.55}
        r={10.67}
        gradientTransform="matrix(.13 0 0 -.13 3504.78 -1156.6)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-4"
        cx={-24571.63}
        cy={-12512.69}
        r={10.79}
        gradientTransform="matrix(.13 0 0 -.13 3504.78 -1153.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-5"
        cx={-24538.51}
        cy={-12316.48}
        r={10.67}
        gradientTransform="matrix(.13 0 0 -.13 3504.78 -1156.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-6"
        cx={33435.74}
        cy={-11966.55}
        r={17.32}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.35)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-7"
        cx={33394.44}
        cy={-11965.91}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.53)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-8"
        cx={33353.7}
        cy={-11966.54}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.35)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-9"
        cx={33450.82}
        cy={-12026.13}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-10"
        cx={33410.07}
        cy={-12026.13}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-11"
        cx={33369.04}
        cy={-12026.13}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-12"
        cx={33452.49}
        cy={-12041.52}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.3)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-13"
        cx={33413.98}
        cy={-12040.08}
        r={17.31}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.31)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-14"
        cx={33372.95}
        cy={-12040.08}
        r={17.32}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.31)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-15"
        cx={33446.52}
        cy={-12123.18}
        r={16.37}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1153.77)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-16"
        cx={33408.06}
        cy={-12087.69}
        r={16.32}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.19)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-17"
        cx={33369.22}
        cy={-12124.99}
        r={16.37}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1153.75)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-18"
        cx={33437.72}
        cy={-12124.68}
        r={15.65}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.19)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-19"
        cx={33402.67}
        cy={-12126.49}
        r={15.66}
        gradientTransform="rotate(180 2290.975 -577.06)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-20"
        cx={33365.56}
        cy={-12118.84}
        r={15.64}
        gradientTransform="rotate(180 2290.975 -577.1)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-21"
        cx={33423.33}
        cy={-12196.8}
        r={15.04}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1153.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-22"
        cx={33391.38}
        cy={-12080.97}
        r={14.3}
        gradientTransform="rotate(180 2290.975 -577.54)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-23"
        cx={33357.47}
        cy={-12097.41}
        r={11.68}
        gradientTransform="rotate(180 2290.975 -577.41)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-24"
        cx={33408.96}
        cy={-12116.7}
        r={14.3}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1155.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-25"
        cx={33378.12}
        cy={-12022.29}
        r={11.99}
        gradientTransform="rotate(180 2290.975 -578.08)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-26"
        cx={33349.5}
        cy={-12131.08}
        r={10.11}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-27"
        cx={33394.22}
        cy={-12152.5}
        r={13.42}
        gradientTransform="rotate(180 2290.975 -577.48)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-28"
        cx={33367.37}
        cy={-12055.86}
        r={11.2}
        gradientTransform="rotate(180 2290.975 -578.02)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-29"
        cx={33341.75}
        cy={-12137.42}
        r={9.55}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1154.87)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-30"
        cx={33375.2}
        cy={-12130.5}
        r={12.4}
        gradientTransform="rotate(180 2290.975 -577.78)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-31"
        cx={33351.9}
        cy={-12154.24}
        r={10.49}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1155.05)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-32"
        cx={33329.61}
        cy={-12056.41}
        r={8.75}
        gradientTransform="rotate(180 2290.975 -578.09)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-33"
        cx={33359.33}
        cy={-12275.16}
        r={11.43}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1153.91)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-34"
        cx={33339.48}
        cy={-12021.03}
        r={9.5}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1157.09)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-35"
        cx={33320.23}
        cy={-12092.12}
        r={8.12}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1155.97)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-36"
        cx={33340.46}
        cy={-12086.9}
        r={9.7}
        gradientTransform="rotate(180 2290.975 -578.33)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-37"
        cx={33324.16}
        cy={-12116.81}
        r={8.22}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.05)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-38"
        cx={33308.22}
        cy={-11906.57}
        r={6.87}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1158.77)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-39"
        cx={33323.86}
        cy={-12121.28}
        r={9.04}
        gradientTransform="rotate(180 2290.975 -578.2)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-40"
        cx={33310.35}
        cy={-12011.31}
        r={7.61}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1157.71)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-41"
        cx={33296.82}
        cy={-12089.08}
        r={6.44}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.47)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-42"
        cx={33307.9}
        cy={-12157.14}
        r={9.03}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.09)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-43"
        cx={33294.39}
        cy={-12092.99}
        r={7.6}
        gradientTransform="rotate(180 2290.975 -578.39)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-44"
        cx={33283.41}
        cy={-12014.95}
        r={6.46}
        gradientTransform="rotate(180 2290.975 -578.84)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-45"
        cx={33271.14}
        cy={-11955.45}
        r={5.94}
        gradientTransform="rotate(180 2290.975 -579.36)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-46"
        cx={33281.19}
        cy={-12160.61}
        r={6.45}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.03)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-47"
        cx={33292.06}
        cy={-12047.62}
        r={6.97}
        gradientTransform="rotate(180 2290.975 -578.9)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-48"
        cx={33258.16}
        cy={-12103.35}
        r={5.57}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.85)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-49"
        cx={33266.23}
        cy={-12082.38}
        r={5.94}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1157.3)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-50"
        cx={33276}
        cy={-12163.35}
        r={6.33}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.31)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-51"
        cx={33245.71}
        cy={-11943.63}
        r={5.06}
        gradientTransform="rotate(180 2290.975 -579.63)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-52"
        cx={33252.93}
        cy={-12012.69}
        r={5.57}
        gradientTransform="rotate(180 2290.975 -579.21)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-53"
        cx={33261.87}
        cy={-11911.89}
        r={5.82}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1160.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-54"
        cx={33235.19}
        cy={-12063.06}
        r={4.91}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1157.67)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-55"
        cx={33241.77}
        cy={-12043.32}
        r={5.22}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1158.09)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-56"
        cx={33248}
        cy={-11900.77}
        r={5.61}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1160.35)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-57"
        cx={33225.16}
        cy={-12137.66}
        r={4.39}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1156.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-58"
        cx={33230.39}
        cy={-12081.61}
        r={4.68}
        gradientTransform="rotate(180 2290.975 -578.82)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-59"
        cx={33235.49}
        cy={-12205.23}
        r={4.99}
        gradientTransform="rotate(180 2290.975 -578.01)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-60"
        cx={33214.58}
        cy={-12196.56}
        r={4.23}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1155.95)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-61"
        cx={33218.3}
        cy={-12057.15}
        r={4.49}
        gradientTransform="rotate(180 2290.975 -579.03)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-62"
        cx={33223.56}
        cy={-12098.32}
        r={4.86}
        gradientTransform="rotate(180 2290.975 -578.81)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-63"
        cx={33205}
        cy={-11970.82}
        r={3.6}
        gradientTransform="rotate(180 2290.975 -579.64)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-64"
        cx={33207.83}
        cy={-12389.02}
        r={3.92}
        gradientTransform="rotate(180 2290.975 -576.73)scale(.13)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-65"
        cx={33211.77}
        cy={-12242.84}
        r={4.19}
        gradientTransform="matrix(-.13 0 0 -.13 4581.95 -1155.61)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-66"
        cx={33329.07}
        cy={-11897.73}
        r={11.65}
        gradientTransform="matrix(-.13 0 0 -.13 4581.73 -1154.61)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-67"
        cx={-24043.95}
        cy={-11966.55}
        r={17.32}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.35)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-68"
        cx={-24085.25}
        cy={-11965.91}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.53)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-69"
        cx={-24126}
        cy={-11966.54}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.35)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-70"
        cx={-24028.87}
        cy={-12026.13}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-71"
        cx={-24069.63}
        cy={-12026.13}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-72"
        cx={-24110.66}
        cy={-12026.13}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-73"
        cx={-24027.2}
        cy={-12041.52}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.3)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-74"
        cx={-24065.72}
        cy={-12040.08}
        r={17.31}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.31)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-75"
        cx={-24106.75}
        cy={-12040.08}
        r={17.32}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.31)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-76"
        cx={-24033.17}
        cy={-12123.18}
        r={16.37}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1153.77)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-77"
        cx={-24071.64}
        cy={-12087.69}
        r={16.32}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.19)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-78"
        cx={-24110.47}
        cy={-12124.99}
        r={16.37}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1153.75)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-79"
        cx={-24041.98}
        cy={-12124.68}
        r={15.65}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.19)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-80"
        cx={-24077.03}
        cy={-12126.49}
        r={15.66}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.12)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-81"
        cx={-24114.14}
        cy={-12118.84}
        r={15.64}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.2)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-82"
        cx={-24056.37}
        cy={-12196.8}
        r={15.04}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1153.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-83"
        cx={-24088.32}
        cy={-12080.97}
        r={14.3}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.08)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-84"
        cx={-24122.22}
        cy={-12097.41}
        r={11.68}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.82)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-85"
        cx={-24070.73}
        cy={-12116.7}
        r={14.3}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-86"
        cx={-24101.58}
        cy={-12022.29}
        r={11.99}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.16)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-87"
        cx={-24130.19}
        cy={-12131.08}
        r={10.11}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-88"
        cx={-24085.48}
        cy={-12152.5}
        r={13.42}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.96)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-89"
        cx={-24112.32}
        cy={-12055.86}
        r={11.2}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.04)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-90"
        cx={-24137.94}
        cy={-12137.42}
        r={9.55}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1154.87)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-91"
        cx={-24104.5}
        cy={-12130.5}
        r={12.4}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.56)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-92"
        cx={-24127.8}
        cy={-12154.24}
        r={10.49}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.05)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-93"
        cx={-24150.09}
        cy={-12056.41}
        r={8.75}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.18)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-94"
        cx={-24120.36}
        cy={-12275.16}
        r={11.43}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1153.91)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-95"
        cx={-24140.21}
        cy={-12021.03}
        r={9.5}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.09)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-96"
        cx={-24159.47}
        cy={-12092.12}
        r={8.12}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.97)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-97"
        cx={-24139.23}
        cy={-12086.9}
        r={9.7}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.66)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-98"
        cx={-24155.53}
        cy={-12116.81}
        r={8.22}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.05)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-99"
        cx={-24171.48}
        cy={-11906.57}
        r={6.87}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1158.77)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-100"
        cx={-24155.84}
        cy={-12121.28}
        r={9.04}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.4)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-101"
        cx={-24169.35}
        cy={-12011.31}
        r={7.61}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.71)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-102"
        cx={-24182.88}
        cy={-12089.08}
        r={6.44}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.47)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-103"
        cx={-24171.8}
        cy={-12157.14}
        r={9.03}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.09)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-104"
        cx={-24185.31}
        cy={-12092.99}
        r={7.6}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.78)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-105"
        cx={-24196.28}
        cy={-12014.95}
        r={6.46}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.68)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-106"
        cx={-24208.55}
        cy={-11955.45}
        r={5.94}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1158.72)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-107"
        cx={-24198.51}
        cy={-12160.61}
        r={6.45}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.03)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-108"
        cx={-24187.63}
        cy={-12047.62}
        r={6.97}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.8)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-109"
        cx={-24221.54}
        cy={-12103.35}
        r={5.57}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.85)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-110"
        cx={-24213.47}
        cy={-12082.38}
        r={5.94}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.3)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-111"
        cx={-24203.7}
        cy={-12163.35}
        r={6.33}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.31)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-112"
        cx={-24233.98}
        cy={-11943.63}
        r={5.06}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1159.26)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-113"
        cx={-24226.77}
        cy={-12012.69}
        r={5.57}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1158.42)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-114"
        cx={-24217.82}
        cy={-11911.89}
        r={5.82}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1160.07)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-115"
        cx={-24244.5}
        cy={-12063.06}
        r={4.91}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.67)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-116"
        cx={-24237.92}
        cy={-12043.32}
        r={5.22}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1158.09)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-117"
        cx={-24231.69}
        cy={-11900.77}
        r={5.61}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1160.35)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-118"
        cx={-24254.54}
        cy={-12137.66}
        r={4.39}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.7)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-119"
        cx={-24249.31}
        cy={-12081.61}
        r={4.68}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.64)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-120"
        cx={-24244.2}
        cy={-12205.23}
        r={4.99}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1156.02)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-121"
        cx={-24265.12}
        cy={-12196.56}
        r={4.23}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.95)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-122"
        cx={-24261.4}
        cy={-12057.15}
        r={4.49}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1158.06)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-123"
        cx={-24256.13}
        cy={-12098.32}
        r={4.86}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1157.62)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-124"
        cx={-24274.69}
        cy={-11970.82}
        r={3.6}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1159.28)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-125"
        cx={-24271.86}
        cy={-12389.02}
        r={3.92}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1153.46)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-126"
        cx={-24267.92}
        cy={-12242.84}
        r={4.19}
        gradientTransform="matrix(.13 0 0 -.13 3504.73 -1155.61)"
      />
      <radialGradient
        xlinkHref="#Costa_Rica_svg__radial-gradient"
        id="Costa_Rica_svg__radial-gradient-127"
        cx={-24150.62}
        cy={-11897.73}
        r={11.65}
        gradientTransform="matrix(.13 0 0 -.13 3504.95 -1154.61)"
      />
      <style>
        {
          ".Costa_Rica_svg__cls-1{fill:#002b7f}.Costa_Rica_svg__cls-151,.Costa_Rica_svg__cls-2{fill:#fff}.Costa_Rica_svg__cls-3{fill:#ce1126}.Costa_Rica_svg__cls-4{fill:#cea849}.Costa_Rica_svg__cls-12,.Costa_Rica_svg__cls-141,.Costa_Rica_svg__cls-143,.Costa_Rica_svg__cls-148,.Costa_Rica_svg__cls-149,.Costa_Rica_svg__cls-150,.Costa_Rica_svg__cls-151,.Costa_Rica_svg__cls-4,.Costa_Rica_svg__cls-6{stroke:#000;stroke-width:.6px}.Costa_Rica_svg__cls-143,.Costa_Rica_svg__cls-149,.Costa_Rica_svg__cls-150,.Costa_Rica_svg__cls-151,.Costa_Rica_svg__cls-4,.Costa_Rica_svg__cls-6{stroke-linecap:round;stroke-linejoin:round}.Costa_Rica_svg__cls-146,.Costa_Rica_svg__cls-148,.Costa_Rica_svg__cls-6{fill:none}.Costa_Rica_svg__cls-12{fill:#825123}.Costa_Rica_svg__cls-149{fill:#89c5e3}.Costa_Rica_svg__cls-140{fill:#509164}.Costa_Rica_svg__cls-139{fill:#034418}.Costa_Rica_svg__cls-141,.Costa_Rica_svg__cls-150{fill:#078930}.Costa_Rica_svg__cls-142{fill:#865800}.Costa_Rica_svg__cls-143,.Costa_Rica_svg__cls-144{fill:#704d25}.Costa_Rica_svg__cls-145{fill:#00009e}.Costa_Rica_svg__cls-147{fill:#ff0016}"
        }
      </style>
    </defs>
    <g id="Costa_Rica_svg__Costa_Rica" data-name="Costa Rica">
      <path d="M0 .6h1280v718.8H0z" className="Costa_Rica_svg__cls-1" />
      <path d="M0 120.4h1280v479.2H0z" className="Costa_Rica_svg__cls-2" />
      <path d="M0 240.2h1280v239.61H0z" className="Costa_Rica_svg__cls-3" />
      <ellipse
        cx={359.4}
        cy={360}
        className="Costa_Rica_svg__cls-2"
        rx={89.85}
        ry={104.83}
      />
      <path
        d="m302.07 345.88 2-3.74-4.79-1.33-1.48 3.31ZM416.73 345.88l-2-3.74 4.79-1.33 1.47 3.31Z"
        className="Costa_Rica_svg__cls-4"
      />
      <path
        d="m358.11 298.35-7.39.21c-4.71.45-6.51 2.27-3.58 5.71-7.6 1.19-15 2.93-21.92 6.56a4.45 4.45 0 0 0-4.82 2.63c-.53 1.5.78 3.1 3.1 2.46-1.54 4.06-19.71 3.58-20.18 10.33 1.38-1.17 2.9-2.17 4.41-1.16l-1 3.15c-2.65.79-4.51 1.23-5.62 4.12s-2.79 7.34-3.93 9.52a4.63 4.63 0 0 0-.93 2.62 2.94 2.94 0 0 0 3 3c2.11 0 3.15-1.32 3.15-2.65-.13-.92-.49-2-2.72-1.88a11.84 11.84 0 0 1 9.16 1.74c3 2.22 3.75 6.52 2 10.06s-6.08 5.45-12.59 2.91a9.36 9.36 0 0 0-12.38 5.37c-8 21.59 6 39.1 21.79 49.31C324 423 327 425.89 331.37 431.08s8.73 11.13 15.17 11.13a5.9 5.9 0 0 0 2.83-.75c4.05 0 4.32 1.51 9.75 1.61h.55c5.45-.1 5.71-1.61 9.76-1.61a5.9 5.9 0 0 0 2.82.75c6.44 0 10.74-5.94 15.17-11.13s7.34-8.09 23.8-18.72C427 402.15 441 384.63 433 363.05a9.36 9.36 0 0 0-12.38-5.37c-6.51 2.54-10.87.53-12.59-2.91s-1-7.84 2-10.06a11.8 11.8 0 0 1 9.15-1.74c-2.24-.13-2.59 1-2.72 1.88 0 1.33 1 2.65 3.15 2.65a2.94 2.94 0 0 0 3-3 4.63 4.63 0 0 0-.93-2.62c-1.14-2.18-2.79-6.61-3.94-9.52s-3-3.33-5.61-4.12l-1-3.15c1.51-1 3 0 4.41 1.16-.47-6.75-18.65-6.27-20.19-10.33 2.33.64 3.64-1 3.11-2.46a4.45 4.45 0 0 0-4.82-2.63c-6.87-3.63-14.32-5.37-21.92-6.56 2.93-3.44 1.13-5.26-3.58-5.71l-7.39-.21h-2.58Z"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: "#dca842",
        }}
      />
      <path
        d="M350 298.66c7.11 0 5.53 8.5-.92 8.89-7.95.92-17.73.66-23 2.85M307.78 321.69c6.14-1.73 12.75-.33 16.77-2.17s4.88-7.9.55-8.7"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M347 304.28c1.41-.33 2.92-.38 3.68-1.07s1-1.92-.83-2.07M323.49 316c1.32-2.22.89-3.77-.83-2.71M368.82 298.66c-7.11 0-5.53 8.5.92 8.89 7.95.92 17.73.66 23 2.85M411 321.69c-6.14-1.73-12.75-.33-16.77-2.17s-4.88-7.9-.55-8.7"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M371.82 304.28c-1.42-.33-2.93-.38-3.69-1.07s-1-1.92.83-2.07M395.31 316c-1.32-2.22-.89-3.77.83-2.71M323.05 418.32c11.38 8 13 18.5 24.8 19"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M348 439c-6.94 1.5-11.48-2.27-17-10.47-2.79-4.12-10.12-9.93-22.64-17.76-19.68-12.28-25.51-33.7-19.11-45.45a7.64 7.64 0 0 1 7.94-3.38c6 1.63 16.21 0 16.25-9.8 0-5.51-4.48-12-10.31-12-3.54 0-5.43 1.17-6.36 2.42"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M347.13 434.8a1.13 1.13 0 0 1 1.15-1.1 1.34 1.34 0 0 1 1.28 1.35c0 1.64-.93 2.52-2.89 2.13-1.61-.32-2.33-2.06-1.65-3.81s3-2.88 5.44-1.78 2.18 4.91 1.32 7.06a6.12 6.12 0 0 1-2.72 3M395.75 418.32c-11.38 8-13 18.5-24.83 19"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M370.81 439c6.94 1.5 11.49-2.27 17-10.47 2.76-4.12 10.12-9.93 22.65-17.76 19.67-12.28 25.5-33.7 19.1-45.45a7.64 7.64 0 0 0-7.94-3.38c-6.05 1.63-16.21 0-16.24-9.8 0-5.51 4.47-12 10.3-12 3.54 0 5.44 1.17 6.37 2.42"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M374 434.55c0-4.88-8.26-6.41-14.59-6.41s-14.6 1.53-14.6 6.41"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M371.67 434.8a1.13 1.13 0 0 0-1.14-1.1 1.34 1.34 0 0 0-1.29 1.35c0 1.64.93 2.52 2.9 2.13 1.61-.32 2.32-2.06 1.64-3.81s-3-2.88-5.43-1.78-2.19 4.91-1.33 7.06a6.12 6.12 0 0 0 2.72 3"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M367.45 439.46c-3.33 0-3.22 3.58-8.05 3.58s-4.69-3.58-8-3.58"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M359.4 434.11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 1 0 0-3.5"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "url(#Costa_Rica_svg__radial-gradient)",
        }}
      />
      <path
        d="M363.66 434.76a1.09 1.09 0 1 0 0 2.17 1.09 1.09 0 1 0 0-2.17"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "url(#Costa_Rica_svg__radial-gradient-2)",
        }}
      />
      <path
        d="M360.51 440.16a1.09 1.09 0 1 0-2.18 0 1.09 1.09 0 1 0 2.18 0"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "url(#Costa_Rica_svg__radial-gradient-3)",
        }}
      />
      <path
        d="M355.14 437a1.1 1.1 0 1 0 0-2.19 1.1 1.1 0 1 0 0 2.19"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "url(#Costa_Rica_svg__radial-gradient-4)",
        }}
      />
      <path
        d="M358.29 431.61a1.09 1.09 0 1 0 2.18 0 1.09 1.09 0 1 0-2.18 0"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "url(#Costa_Rica_svg__radial-gradient-5)",
        }}
      />
      <g id="Costa_Rica_svg__g">
        <path
          d="M311 331.75a3.6 3.6 0 0 1 1.19.28 2.43 2.43 0 0 1 1.46 1.43c5.88 16.31 2.74 23.27-2.49 33.83-7.54 15.2-2 37.85 14.81 47.76a68.5 68.5 0 0 0 19.58 7.72 43 43 0 0 1 6.28 1.87 11.5 11.5 0 0 1 4.55 3.53 37 37 0 0 0-5.81 1c-2-2.51-6.94-4.82-12.07-6.56a113 113 0 0 0-13.39-3.57c-9.45-2.74-18.26-8.89-24.9-16.7a40.54 40.54 0 0 1-9.23-31c.31-2.59 1.34-4.18 2.82-5a9.27 9.27 0 0 1 5.3-.88 17.6 17.6 0 0 0 10.32-2.75c4.15-2.55 5.85-7.06 5.78-12a25 25 0 0 0-4.85-14.08 5.63 5.63 0 0 1-1.44-3.29 1.61 1.61 0 0 1 1.2-1.55 2.7 2.7 0 0 1 .51-.09Z"
          className="Costa_Rica_svg__cls-12"
        />
        <path
          d="M296.08 366.78a2.12 2.12 0 1 0 0 4.23 2.12 2.12 0 1 0 0-4.23"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-6)",
          }}
        />
        <path
          d="M301.37 366.52a2.11 2.11 0 1 0 0 4.22 2.11 2.11 0 1 0 0-4.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-7)",
          }}
        />
        <path
          d="M306.59 366.78a2.11 2.11 0 1 0 0 4.23 2.11 2.11 0 1 0 0-4.23"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-8)",
          }}
        />
        <path
          d="M294.14 371.47a2.11 2.11 0 1 0 0 4.21 2.11 2.11 0 1 0 0-4.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-9)",
          }}
        />
        <path
          d="M299.37 371.47a2.11 2.11 0 1 0 0 4.21 2.11 2.11 0 1 0 0-4.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-10)",
          }}
        />
        <path
          d="M304.63 371.47a2.11 2.11 0 1 0 0 4.21 2.11 2.11 0 1 0 0-4.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-11)",
          }}
        />
        <path
          d="M293.93 376.37a2.12 2.12 0 1 0 0 4.23 2.12 2.12 0 1 0 0-4.23"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-12)",
          }}
        />
        <path
          d="M298.87 376.19a2.11 2.11 0 1 0 0 4.22 2.11 2.11 0 1 0 0-4.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-13)",
          }}
        />
        <path
          d="M304.13 376.19a2.11 2.11 0 1 0 0 4.22 2.11 2.11 0 1 0 0-4.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-14)",
          }}
        />
        <path
          d="M294.68 381.38a2 2 0 1 0 0 4 2 2 0 1 0 0-4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-15)",
          }}
        />
        <path
          d="M299.62 381.38a2 2 0 1 0 0 4 2 2 0 1 0 0-4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-16)",
          }}
        />
        <path
          d="M304.59 381.38a2 2 0 1 0 0 4 2 2 0 1 0 0-4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-17)",
          }}
        />
        <path
          d="M295.73 386.56a1.9 1.9 0 1 0 .18 3.79 1.9 1.9 0 1 0-.18-3.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-18)",
          }}
        />
        <path
          d="M300.23 386a1.9 1.9 0 1 0 .18 3.79 1.9 1.9 0 1 0-.18-3.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-19)",
          }}
        />
        <path
          d="M305 385.81a1.9 1.9 0 1 0 .17 3.8 1.9 1.9 0 1 0-.17-3.8"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-20)",
          }}
        />
        <path
          d="M297.54 391a1.81 1.81 0 1 0 .25 3.61 1.81 1.81 0 1 0-.25-3.61"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-21)",
          }}
        />
        <path
          d="M301.66 390.43a1.74 1.74 0 0 0 .21 3.47 1.74 1.74 0 1 0-.21-3.47"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-22)",
          }}
        />
        <path
          d="M306 390.21a1.4 1.4 0 1 0 .18 2.79 1.4 1.4 0 1 0-.18-2.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-23)",
          }}
        />
        <path
          d="M299.4 395a1.74 1.74 0 0 0 .22 3.47 1.74 1.74 0 1 0-.22-3.47"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-24)",
          }}
        />
        <path
          d="M303.37 394.07a1.46 1.46 0 0 0 .18 2.91 1.46 1.46 0 1 0-.18-2.91"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-25)",
          }}
        />
        <path
          d="M307.06 393.58a1.2 1.2 0 0 0 .14 2.39 1.2 1.2 0 1 0-.14-2.39"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-26)",
          }}
        />
        <path
          d="M301.05 398.62a1.61 1.61 0 1 0 .71 3.15 1.61 1.61 0 1 0-.71-3.15"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-27)",
          }}
        />
        <path
          d="M304.56 397.23a1.34 1.34 0 1 0 .57 2.61 1.34 1.34 0 1 0-.57-2.61"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-28)",
          }}
        />
        <path
          d="M307.88 396.23a1.12 1.12 0 1 0 .5 2.18 1.12 1.12 0 1 0-.5-2.18"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-29)",
          }}
        />
        <path
          d="M303.34 401.88a1.48 1.48 0 0 0 1 2.79 1.48 1.48 0 1 0-1-2.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-30)",
          }}
        />
        <path
          d="M306.42 400.19a1.24 1.24 0 1 0 .82 2.33 1.24 1.24 0 1 0-.82-2.33"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-31)",
          }}
        />
        <path
          d="M309.35 399a1 1 0 1 0 .68 1.92 1 1 0 1 0-.68-1.92"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-32)",
          }}
        />
        <path
          d="M305.31 404.63a1.34 1.34 0 1 0 1.14 2.43 1.34 1.34 0 1 0-1.14-2.43"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-33)",
          }}
        />
        <path
          d="M308 402.84a1.12 1.12 0 0 0 .93 2 1.12 1.12 0 0 0-.93-2"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-34)",
          }}
        />
        <path
          d="M310.49 401.45a.94.94 0 0 0 .79 1.71.94.94 0 1 0-.79-1.71"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-35)",
          }}
        />
        <path
          d="M307.78 406.92a1.14 1.14 0 0 0 1 2 1.14 1.14 0 0 0-1-2"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-36)",
          }}
        />
        <path
          d="M310 405.31a.94.94 0 1 0 .86 1.68.94.94 0 1 0-.86-1.68"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-37)",
          }}
        />
        <path
          d="M312.07 404a.78.78 0 0 0 .71 1.4c.93-.47.22-1.93-.71-1.4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-38)",
          }}
        />
        <path
          d="M309.85 408.92a1 1 0 0 0 1.14 1.76 1 1 0 1 0-1.14-1.76"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-39)",
          }}
        />
        <path
          d="M311.67 407.28a.88.88 0 0 0 1 1.47c1-.64 0-2.16-1-1.47"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-40)",
          }}
        />
        <path
          d="M313.5 405.88a.73.73 0 1 0 .79 1.22.73.73 0 0 0-.79-1.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-41)",
          }}
        />
        <path
          d="M311.9 410.57a1 1 0 1 0 1.14 1.75 1 1 0 1 0-1.14-1.75"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-42)",
          }}
        />
        <path
          d="M313.72 409a.88.88 0 0 0 1 1.46.88.88 0 0 0-1-1.46"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-43)",
          }}
        />
        <path
          d="M315.22 407.57a.72.72 0 1 0 .78 1.21c.83-.54 0-1.79-.78-1.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-44)",
          }}
        />
        <path
          d="M316.82 409.28a.67.67 0 0 0 .72 1.14c.75-.49 0-1.64-.72-1.14"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-45)",
          }}
        />
        <path
          d="M315.5 410.75a.72.72 0 1 0 .79 1.21.72.72 0 1 0-.79-1.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-46)",
          }}
        />
        <path
          d="M314.07 412.25a.79.79 0 1 0 .86 1.32.79.79 0 1 0-.86-1.32"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-47)",
          }}
        />
        <path
          d="M318.51 411a.62.62 0 0 0 .68 1 .62.62 0 1 0-.68-1"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-48)",
          }}
        />
        <path
          d="M317.45 412.32a.66.66 0 1 0 .72 1.11.66.66 0 1 0-.72-1.11"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-49)",
          }}
        />
        <path
          d="M316.17 413.6a.71.71 0 0 0 .78 1.18.71.71 0 1 0-.78-1.18"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-50)",
          }}
        />
        <path
          d="M320.14 412.2c-.61.4 0 1.37.61.94s0-1.36-.61-.94"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-51)",
          }}
        />
        <path
          d="M319.18 413.4a.63.63 0 0 0 .68 1.05.63.63 0 0 0-.68-1.05"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-52)",
          }}
        />
        <path
          d="M318 414.77c-.71.46 0 1.61.72 1.07s0-1.61-.72-1.07"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-53)",
          }}
        />
        <path
          d="M321.48 413.25a.54.54 0 1 0 .64.86.54.54 0 0 0-.64-.86"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-54)",
          }}
        />
        <path
          d="M320.61 414.38a.57.57 0 1 0 .68.92.57.57 0 1 0-.68-.92"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-55)",
          }}
        />
        <path
          d="M319.78 415.58a.63.63 0 1 0 .75 1c.64-.5-.08-1.54-.75-1"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-56)",
          }}
        />
        <path
          d="M322.77 414.08a.46.46 0 1 0 .61.68.46.46 0 1 0-.61-.68"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-57)",
          }}
        />
        <path
          d="M322.06 415.27c-.47.42.18 1.21.68.71a.49.49 0 1 0-.68-.71"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-58)",
          }}
        />
        <path
          d="M321.4 416.4a.53.53 0 1 0 .71.79.53.53 0 1 0-.71-.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-59)",
          }}
        />
        <path
          d="M324.13 414.77a.44.44 0 0 0 .61.64.44.44 0 1 0-.61-.64"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-60)",
          }}
        />
        <path
          d="M323.64 415.84a.47.47 0 1 0 .64.68c.46-.44-.18-1.15-.64-.68"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-61)",
          }}
        />
        <path
          d="M322.92 417a.52.52 0 1 0 .72.76.52.52 0 1 0-.72-.76"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-62)",
          }}
        />
        <path
          d="M325.39 415.58c-.32.35.22.86.54.5s-.18-.9-.54-.5"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-63)",
          }}
        />
        <path
          d="M325 416.56a.4.4 0 1 0 .61.53.4.4 0 0 0-.61-.53"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-64)",
          }}
        />
        <path
          d="M324.47 417.59a.43.43 0 1 0 .65.57.43.43 0 1 0-.65-.57"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-65)",
          }}
        />
        <path
          d="M309.52 363.86a1.39 1.39 0 0 0 0 2.79 1.39 1.39 0 1 0 0-2.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-66)",
          }}
        />
      </g>
      <g id="Costa_Rica_svg__g-2" data-name="g">
        <path
          d="M407.76 331.75a3.6 3.6 0 0 0-1.19.28 2.41 2.41 0 0 0-1.45 1.43c-5.88 16.31-2.73 23.27 2.49 33.83 7.55 15.2 2 37.85-14.81 47.76a68.5 68.5 0 0 1-19.58 7.72 43.5 43.5 0 0 0-6.28 1.87 11.65 11.65 0 0 0-4.55 3.53 37 37 0 0 1 5.82 1c2-2.51 6.93-4.82 12.06-6.56a113 113 0 0 1 13.4-3.57c9.45-2.74 18.26-8.89 24.9-16.7a40.54 40.54 0 0 0 9.23-31c-.31-2.59-1.34-4.18-2.81-5a9.3 9.3 0 0 0-5.31-.88 17.6 17.6 0 0 1-10.32-2.75c-4.15-2.55-5.84-7.06-5.78-12a25 25 0 0 1 4.85-14.08 5.73 5.73 0 0 0 1.45-3.29 1.63 1.63 0 0 0-1.21-1.55 3 3 0 0 0-.5-.09Z"
          className="Costa_Rica_svg__cls-12"
        />
        <path
          d="M422.72 366.78a2.12 2.12 0 1 1 0 4.23 2.12 2.12 0 1 1 0-4.23"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-67)",
          }}
        />
        <path
          d="M417.43 366.52a2.11 2.11 0 1 1 0 4.22 2.11 2.11 0 1 1 0-4.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-68)",
          }}
        />
        <path
          d="M412.21 366.78a2.12 2.12 0 1 1 0 4.23 2.12 2.12 0 1 1 0-4.23"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-69)",
          }}
        />
        <path
          d="M424.66 371.47a2.11 2.11 0 1 1 0 4.21 2.11 2.11 0 1 1 0-4.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-70)",
          }}
        />
        <path
          d="M419.43 371.47a2.11 2.11 0 1 1 0 4.21 2.11 2.11 0 1 1 0-4.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-71)",
          }}
        />
        <path
          d="M414.17 371.47a2.11 2.11 0 1 1 0 4.21 2.11 2.11 0 1 1 0-4.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-72)",
          }}
        />
        <path
          d="M424.87 376.37a2.12 2.12 0 1 1 0 4.23 2.12 2.12 0 1 1 0-4.23"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-73)",
          }}
        />
        <path
          d="M419.94 376.19a2.11 2.11 0 1 1 0 4.22 2.11 2.11 0 1 1 0-4.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-74)",
          }}
        />
        <path
          d="M414.68 376.19a2.11 2.11 0 1 1 0 4.22 2.11 2.11 0 1 1 0-4.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-75)",
          }}
        />
        <path
          d="M424.12 381.38a2 2 0 1 1 0 4 2 2 0 1 1 0-4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-76)",
          }}
        />
        <path
          d="M419.18 381.38a2 2 0 1 1 0 4 2 2 0 1 1 0-4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-77)",
          }}
        />
        <path
          d="M414.21 381.38a2 2 0 1 1 0 4 2 2 0 1 1 0-4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-78)",
          }}
        />
        <path
          d="M423.07 386.56a1.9 1.9 0 1 1-.18 3.79 1.9 1.9 0 1 1 .18-3.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-79)",
          }}
        />
        <path
          d="M418.58 386a1.9 1.9 0 1 1-.18 3.79 1.9 1.9 0 1 1 .18-3.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-80)",
          }}
        />
        <path
          d="M413.82 385.81a1.9 1.9 0 1 1-.18 3.8 1.9 1.9 0 1 1 .18-3.8"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-81)",
          }}
        />
        <path
          d="M421.26 391a1.81 1.81 0 1 1-.25 3.61 1.81 1.81 0 1 1 .25-3.61"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-82)",
          }}
        />
        <path
          d="M417.15 390.43a1.74 1.74 0 0 1-.22 3.47 1.74 1.74 0 1 1 .22-3.47"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-83)",
          }}
        />
        <path
          d="M412.78 390.21a1.4 1.4 0 1 1-.18 2.79 1.4 1.4 0 1 1 .18-2.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-84)",
          }}
        />
        <path
          d="M419.4 395a1.74 1.74 0 0 1-.22 3.47 1.74 1.74 0 1 1 .22-3.47"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-85)",
          }}
        />
        <path
          d="M415.43 394.07a1.46 1.46 0 0 1-.18 2.91 1.46 1.46 0 0 1 .18-2.91"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-86)",
          }}
        />
        <path
          d="M411.74 393.58a1.2 1.2 0 0 1-.14 2.39 1.2 1.2 0 1 1 .14-2.39"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-87)",
          }}
        />
        <path
          d="M417.75 398.62a1.61 1.61 0 1 1-.71 3.15 1.61 1.61 0 1 1 .71-3.15"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-88)",
          }}
        />
        <path
          d="M414.25 397.23a1.34 1.34 0 1 1-.58 2.61 1.34 1.34 0 1 1 .58-2.61"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-89)",
          }}
        />
        <path
          d="M410.92 396.23a1.12 1.12 0 1 1-.5 2.18 1.12 1.12 0 1 1 .5-2.18"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-90)",
          }}
        />
        <path
          d="M415.46 401.88a1.48 1.48 0 0 1-1 2.79 1.48 1.48 0 1 1 1-2.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-91)",
          }}
        />
        <path
          d="M412.39 400.19a1.24 1.24 0 1 1-.83 2.33 1.24 1.24 0 1 1 .83-2.33"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-92)",
          }}
        />
        <path
          d="M409.45 399a1 1 0 1 1-.68 1.92 1 1 0 1 1 .68-1.92"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-93)",
          }}
        />
        <path
          d="M413.5 404.63a1.34 1.34 0 1 1-1.15 2.43 1.34 1.34 0 1 1 1.15-2.43"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-94)",
          }}
        />
        <path
          d="M410.85 402.84a1.12 1.12 0 0 1-.93 2 1.12 1.12 0 1 1 .93-2"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-95)",
          }}
        />
        <path
          d="M408.31 401.45a.94.94 0 0 1-.79 1.71.94.94 0 1 1 .79-1.71"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-96)",
          }}
        />
        <path
          d="M411 406.92a1.14 1.14 0 0 1-1 2 1.14 1.14 0 1 1 1-2"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-97)",
          }}
        />
        <path
          d="M408.85 405.31A.94.94 0 1 1 408 407a.94.94 0 1 1 .86-1.68"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-98)",
          }}
        />
        <path
          d="M406.73 404a.78.78 0 0 1-.71 1.4c-.93-.47-.22-1.93.71-1.4"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-99)",
          }}
        />
        <path
          d="M409 408.92a1 1 0 0 1-1.14 1.76 1 1 0 1 1 1.14-1.76"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-100)",
          }}
        />
        <path
          d="M407.13 407.28a.88.88 0 0 1-1 1.47c-1-.64 0-2.16 1-1.47"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-101)",
          }}
        />
        <path
          d="M405.3 405.88a.72.72 0 1 1-.78 1.22.72.72 0 0 1 .78-1.22"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-102)",
          }}
        />
        <path
          d="M406.91 410.57a1 1 0 1 1-1.15 1.75 1 1 0 1 1 1.15-1.75"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-103)",
          }}
        />
        <path
          d="M405.08 409a.87.87 0 0 1-1 1.46.87.87 0 0 1 1-1.46"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-104)",
          }}
        />
        <path
          d="M403.59 407.57a.72.72 0 1 1-.79 1.21c-.82-.54 0-1.79.79-1.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-105)",
          }}
        />
        <path
          d="M402 409.28a.67.67 0 0 1-.72 1.14c-.75-.49 0-1.64.72-1.14"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-106)",
          }}
        />
        <path
          d="M403.3 410.75a.72.72 0 1 1-.79 1.21.72.72 0 1 1 .79-1.21"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-107)",
          }}
        />
        <path
          d="M404.73 412.25a.79.79 0 1 1-.86 1.32.79.79 0 1 1 .86-1.32"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-108)",
          }}
        />
        <path
          d="M400.29 411a.61.61 0 0 1-.67 1 .61.61 0 1 1 .67-1"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-109)",
          }}
        />
        <path
          d="M401.35 412.32a.66.66 0 1 1-.72 1.11.66.66 0 1 1 .72-1.11"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-110)",
          }}
        />
        <path
          d="M402.64 413.6a.71.71 0 0 1-.79 1.18.71.71 0 1 1 .79-1.18"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-111)",
          }}
        />
        <path
          d="M398.66 412.2c.61.4 0 1.37-.6.94s0-1.36.6-.94"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-112)",
          }}
        />
        <path
          d="M399.62 413.4a.63.63 0 0 1-.68 1.05c-.67-.47 0-1.51.68-1.05"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-113)",
          }}
        />
        <path
          d="M400.79 414.77c.71.46 0 1.61-.72 1.07s0-1.61.72-1.07"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-114)",
          }}
        />
        <path
          d="M397.33 413.25a.54.54 0 0 1-.65.86.54.54 0 0 1 .65-.86"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-115)",
          }}
        />
        <path
          d="M398.19 414.38a.57.57 0 1 1-.68.92c-.6-.46.08-1.39.68-.92"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-116)",
          }}
        />
        <path
          d="M399 415.58c.64.5-.07 1.53-.75 1s.07-1.54.75-1"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-117)",
          }}
        />
        <path
          d="M396 414.08a.46.46 0 1 1-.61.68.46.46 0 1 1 .61-.68"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-118)",
          }}
        />
        <path
          d="M396.74 415.27c.47.42-.17 1.21-.68.71a.49.49 0 1 1 .68-.71"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-119)",
          }}
        />
        <path
          d="M397.41 416.4a.53.53 0 1 1-.72.79.53.53 0 1 1 .72-.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-120)",
          }}
        />
        <path
          d="M394.67 414.77a.44.44 0 0 1-.61.64.44.44 0 1 1 .61-.64"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-121)",
          }}
        />
        <path
          d="M395.17 415.84a.47.47 0 1 1-.65.68.47.47 0 1 1 .65-.68"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-122)",
          }}
        />
        <path
          d="M395.88 417c.5.51-.21 1.26-.71.76a.52.52 0 1 1 .71-.76"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-123)",
          }}
        />
        <path
          d="M393.41 415.58c.32.35-.21.86-.53.5s.17-.9.53-.5"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-124)",
          }}
        />
        <path
          d="M393.8 416.56a.4.4 0 1 1-.61.53.4.4 0 0 1 .61-.53"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-125)",
          }}
        />
        <path
          d="M394.33 417.59a.43.43 0 1 1-.64.57.43.43 0 1 1 .64-.57"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-126)",
          }}
        />
        <path
          d="M409.28 363.86a1.39 1.39 0 0 1 0 2.79 1.39 1.39 0 1 1 0-2.79"
          style={{
            stroke: "#000",
            strokeWidth: ".6px",
            fill: "url(#Costa_Rica_svg__radial-gradient-127)",
          }}
        />
      </g>
      <path
        d="M316.22 361.31c2.08-6.91 3.11-15.78.18-27.33 12.91-8.34 22-16 43-16s30.91 5.79 43 16c-2.89 11.55-1.86 20.39.18 27.33h-86.5"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "#89c5e3",
        }}
      />
      <path
        d="m326.05 344.49-1 10.44-3.71-10.34 1.79 10.93-4.13-5.45 2.48 6.49-3-2.11 1.85 3.46a.2.2 0 0 1-.05.07l-2.16-.26 1.34 1.88a7 7 0 0 0-.46 2.4s0 .07 0 .11h14.3V362a7 7 0 0 0-.42-2.44l2.82-2.7-3.55 1.24a1 1 0 0 0-.08-.14c.54-.67 5.88-7.23 5.66-7.23s-6.75 5.59-7 5.79l5.12-11.33-7.08 10.17h-.07l2.08-10.74-3.78 10.29-1-10.41Z"
        style={{
          fill: "#fcdd09",
        }}
      />
      <path
        d="M316.16 361.31a79 79 0 0 1-3.83 9.87c-3.25 7.34-3.93 24.4 8.09 36.46 17.85 17.85 31.44 10.66 38.28 20.38h1.39c6.83-9.72 20.43-2.53 38.28-20.38 12-12.06 11.38-29.12 8.09-36.46a81 81 0 0 1-3.83-9.87h-86.5"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "#0f47af",
        }}
      />
      <path
        d="M342.29 344.89c-.21-1-2.54-.81-2.37-2.42-1.56-.25-1.27-3 1.63-2.84.31-.55 3.81-1.81 3.39-.06 1.76-1.54 3-.13 2.05.55.68.68 1 2.23-1.06 2.09.8 1.42-1.05 1.37-2.28 1 0 .54-.06 1-.76.83-.44.3-.11.68-.05 1ZM374.46 346c0-1.26-2.36-.88-2.27-2.32-1.29-.2-1.1-2.87 1.57-2.71-.15-.77 3.59-1.77 3.24-.07 1.31-1.38 2.59-.09 1.8.53.65.65 1.44 1.77-.85 2 .92.9-1 1.31-2.18.93 0 .51-.32.69-1 .56-.42.29.15.88.21 1.22l-.53-.15ZM393 350.34c.22-.95-2-.87-1.91-2-1-.15-.85-2.17 1.2-2.05-.11-.59 2.56-1.57 2.38-.14 1-1.05 2.11 0 1.5.49.5.49 1.1 1.34-.66 1.52.71.68-.77 1-1.67.7 0 .39-.11.45-.62.36-.32.21.39.74.44 1l-.66.09Z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M385.56 368.57c.54-2.79 2.84-5.37 3.09-7.55a10.7 10.7 0 0 1 1.75-4.86 13.3 13.3 0 0 0 1.87-4.48c.35-1.86 1.75-2.25 2.4-.36s1.83 6.66 2.47 7.77a7.6 7.6 0 0 1 1.15 3.4c-.11.75.82 1 1.36 1.57s.61 2.26 2.19 3.76a20.3 20.3 0 0 0 4.8 3.32 29.45 29.45 0 0 1 2 12.63h-98.45c0-1.35 0-2.68.07-4 8.75-2.26 12-8 15.7-7.62a54 54 0 0 1 6.13-7.34c2-1.82 6-9.08 7-13.53s2.47-6.75 3.59-6.51 1.57.47 2.9 4.44c1.83 5.47 3.08 6.12 4.48 10.05 1.22 3.41 3.76 9.52 7.67 12.7 2.44-1.82 5.23-3.86 6.13-5.29a13.6 13.6 0 0 1 3.26-4.11c.61-1.82 1.4-5.09 2-5.87A4 4 0 0 0 370 354a16.5 16.5 0 0 1 2.33-6.11c1.33-2.18 3.09-2.9 3.88 0a103 103 0 0 0 4.15 12.77 29.3 29.3 0 0 0 4.7 7.94l.3.35a1.1 1.1 0 0 0 .16-.42Z"
        style={{
          stroke: "#000",
          strokeWidth: ".6px",
          fill: "#509164",
        }}
      />
      <path
        d="M374.28 378.87c-1.83-1.76-4.73-1.37-6.2-2.76s-3.73-.43-8.68-2.93a12.6 12.6 0 0 1-1.83-1.18c-3.9-3.19-6.45-9.31-7.67-12.7-1.36-3.9-2.65-4.55-4.48-10.06-1-2.93-1.5-3.83-2.15-4.15 1.69 1.83.79 4.69 2.15 7.77.54 1.22-.35 1.22-.64.82a1.93 1.93 0 0 0-1.47-.54c.72.62.82 2.15 1.54 3.76s-.54 1.44.93 3.72c.4.65.54 1.61 0 2s-1-1.11-1.94-.6a9.7 9.7 0 0 0 2 2.21c.68.62 0 .94-.5.65a11.4 11.4 0 0 1-1.72-.89c0 .46.57 1 1.36 1.71s.29 1.18-1.61 1.18a1.12 1.12 0 0 1-.68 1.65c1.18.07 2.08 2.25 3.55 2.4s1.57 1.11.18 1.35-4.23-2-5.63-3.47a1.34 1.34 0 0 1-1.65.43 7.2 7.2 0 0 0 .82 3.4 8.1 8.1 0 0 1-2.47-2.29c-.86-1-1.43.5-.68 1.43s1.26 1.68 0 2.4-1.94.43-2.83-.83c-1.26 1-1.76 1.11-2.73.94 0 .6-1 2-1.5 3.11-1 2.07 46.09 6.37 44.76 1.36"
        className="Costa_Rica_svg__cls-139"
      />
      <path
        d="M408.18 379.19c-12.41-1.09-19.25-5.88-23.12-10.45a29 29 0 0 1-4.7-7.94 104 104 0 0 1-4.15-12.8 2.6 2.6 0 0 0-1-1.75c-.65-.32-.33.79.14 1.36s.47 1-.18.65-1 .35-.36 1.24a9.1 9.1 0 0 1 1.65 2.83 4.34 4.34 0 0 0 .72 2.22c.43.46-1.19.57-1.87-.53 0 .71.18 1.75.65 1.64s.57.32 0 1.4-.53 1.39-.32 1.86c.32.71 1.15-2.12 1.65-.51a11.2 11.2 0 0 0 1.07 2.29c.4.58.36.94-.21.94s-1.08-1.44-1.15-.22.9 1.57 1.87 1.5 1.07.32.93.82a.72.72 0 0 0 .82.9c.5-.15 1.29.32 1.72 1.54s-.28 1.75-1.32.89-2.55-1.68-2.69-2.33-.54.26-.07 1a3.07 3.07 0 0 0 1.25 1.47c.57.28 0 1.47-1 .71s-1.36-.54-1.65.29c-.47 1.33-1.86 1-1.43 1.72a1.59 1.59 0 0 1-.4 2.14c-.68.29-1.47-.13-1.4-1.39a1.52 1.52 0 0 1-1.39.21c-.08 1.76-.58 2.36-1.65 1.9a2.27 2.27 0 0 1-.61 1.57 1.24 1.24 0 0 1 1.54 1.15c.07.5.25.43.93.5s1.47.89.25.68-3.12.25-4.23-.57c1.15 1 4.41 1.07 5.77 2.39 9.93 4.09 27.42 5.51 34.34 3.62a31 31 0 0 0-.15-3.33"
        className="Costa_Rica_svg__cls-139"
      />
      <path
        d="M393.78 350.19a2.17 2.17 0 0 1 .82 1.15c.61 1.89 1.83 6.65 2.48 7.76a7.6 7.6 0 0 1 1.14 3.39c-.11.75.83 1.05 1.36 1.58s.61 2.25 2.19 3.75a20.6 20.6 0 0 0 4.8 3.34 25 25 0 0 1 1.87 7.83 43.8 43.8 0 0 1-12.19-2.76 3.5 3.5 0 0 0 0-1.64 1.89 1.89 0 0 1 .76-2 2.11 2.11 0 0 0 .11-2.61c-.43-.64-.4-1 0-1.43s.32-1-.43-1.72-.25-1.47.18-2.11a3.58 3.58 0 0 0 .61-3.19c-.47-1.39-1.19.33-1.76-.21a1.28 1.28 0 0 1-.18-1.61c.4-.54.15-1.57-.32-2.36 1-.28-.72-3.33-1-4.62s.32-1.93-.36-2.43"
        className="Costa_Rica_svg__cls-139"
      />
      <path
        d="M348.68 361.81a5.5 5.5 0 0 1-.36 2 6.25 6.25 0 0 1 .94 2.5c.57-.53 1.68-.11 1.93 1.36a14.2 14.2 0 0 1 .36 3.72c.5.43 1.58 1.18 1.76 2s.71.68 1.25.6c1.69-.25 1.54 1.79 3.3 1.5 2.47-.35.93 1.62 3.4 1.54 1.44-.07 3.41.21 4.41 1.61 1.11-1.5 2.08-.93 3.08-.54s2.26.26 1.15-.53a6.58 6.58 0 0 0-4.41-.68 4.11 4.11 0 0 1-3.55-.86 7.1 7.1 0 0 0-3.83-1.75c-1.08 0-1.33-.1-2.15-1.32a3.07 3.07 0 0 0-2.73-1.11c-.6 0-1.07-.83-.35-1.58 1-1.1-.43-1.25.1-1.93s.25-1.57-1.18-1.68-.89-.57-.68-1.58c.5-2.39-2.72-2-2.47-3.14M405 374.69c.15-1.47-1-2.07-1.21-3.19s-2-1.14-2.44-.82a1.35 1.35 0 0 1-.22 1.21c-.21.3-.21.47.22.62s.86.21.89.6.26 0 .43-.43 1.4.58 1.55 1.5.61 1.58.75.47M399.15 373.11c.21.54 1 1.29 1.43 1.29a1.26 1.26 0 0 1 1.18.83c.08.43.43 1 .9 1.11s.22.43-.36.39-1.54-.39-1.61-.83c.21.9-.07 1.3-.65.65s-.82-1.47-1.54-1.58c.54-.1.61-.25.36-.79s0-2 .29-1.07"
        className="Costa_Rica_svg__cls-140"
      />
      <path
        d="M310.27 382.09a4 4 0 0 1 3.68.25 1.73 1.73 0 0 1 2-1c.86-.93 1.57-1.4 2.07-.93a25.3 25.3 0 0 0 5.39-1.43c1.07-1.4 3-1.89 4.11-1.18a2.1 2.1 0 0 1 2.64-.11c.5.47 1.57-.49 2 .39.75-.17 2.18-.21 2.46.58a.8.8 0 0 1 1.18-.36c0-1.65 1.18-2.9 2.82-2.51.79-1.18 2.15-1.67 2.79-1.25.68-.68 2.07-.21 2.68.61 1.32 0 2 .57 2.64 1.75a3.48 3.48 0 0 0 3.89 1.37c1.25-.47 2.39-.62 2.82 0a1.46 1.46 0 0 1 2.07 0c.86.75 1.68-.57 2.18-.07.79.82 1.5-.75 2.89.07a13.84 13.84 0 0 0 6.11 2.07c2.07 0 3.71-2.53 5-.75a4.91 4.91 0 0 1 4.72-.57c.82-.75 2.71-1 3.46-.28a3.14 3.14 0 0 1 3.39-1.44 2.65 2.65 0 0 1 4.22.3c.67 0 1.75.6 1.75 1.35.67 0 1.75.43 1.75 1.22a1.5 1.5 0 0 1 1.82 1.18 3.36 3.36 0 0 1 3.39 1.75c.5-.43.21-1.54 1.36-1.75s1.5.17 1.82.57a3.44 3.44 0 0 1 4.46.5c1.07-.43 2.07-.25 2.39.29a2.93 2.93 0 0 1 2-.54 38 38 0 0 1-.72 7.8h-96.69a38.7 38.7 0 0 1-.68-7.73"
        className="Costa_Rica_svg__cls-141"
      />
      <path
        d="m359.36 326.66-1 3.11h-3.29l2.68 1.93-1 3.12 2.61-1.94 2.65 1.94-1-3.12 2.64-1.86h-3.25l-1-3.11M346.91 327.69l-.46 3.23-3.22.5 2.93 1.46-.5 3.22 2.29-2.33 2.9 1.48-1.5-2.91 2.32-2.29-3.22.51-1.5-2.91M334.75 330.73v3.26l-3.11 1 3.14 1v3.25l1.86-2.68 3.12 1-2-2.62 1.9-2.65-3.12 1-2-2.61M323.27 335.7l.57 3.23-2.9 1.54 3.26.43.53 3.21 1.4-2.93 3.22.43-2.35-2.29 1.43-2.9-2.9 1.54-2.36-2.26M371.89 327.69l.46 3.23 3.22.5-2.93 1.46.5 3.22-2.29-2.33-2.9 1.48 1.5-2.91-2.29-2.29 3.22.51 1.51-2.91M384.05 330.73v3.26l3.12 1L384 336v3.25l-1.86-2.68-3.11 1 2-2.62-1.89-2.65 3.07 1 2-2.61M395.53 335.7l-.57 3.23 2.9 1.54-3.26.43-.53 3.21-1.4-2.93-3.22.43 2.36-2.29-1.43-2.9 2.9 1.54 2.36-2.26"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m354 405.43.36-23.93c0-1.15.22-1.33.25-.07l.07 24.26"
        className="Costa_Rica_svg__cls-142"
      />
      <path
        d="m354 405.43.36-23.93c0-1.15.22-1.33.25-.07l.07 24.26"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="M354.65 381.46c.82-.71 2.71.9 3.9.22-.72 2.32-3.58.5-3.9 1.36z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M354.65 381.46c.82-.71 2.71.9 3.9.22-.72 2.32-3.58.5-3.9 1.36z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m362.09 405.47.35-23.9c0-1.14.22-1.36.26 0l.07 24.21"
        className="Costa_Rica_svg__cls-142"
      />
      <path
        d="m362.09 405.47.35-23.9c0-1.14.22-1.36.26 0l.07 24.21"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="M362.77 381.54c.82-.72 2.72.89 3.9.21-.75 2.32-3.58.5-3.9 1.36z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M362.77 381.54c.82-.72 2.72.89 3.9.21-.75 2.32-3.58.5-3.9 1.36z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m369.74 406.8.36-23.94c0-1.15.21-1.32.25 0l.07 24.21"
        className="Costa_Rica_svg__cls-142"
      />
      <path
        d="m369.74 406.8.36-23.94c0-1.15.21-1.32.25 0l.07 24.21"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="M370.39 382.86c.82-.72 2.72.89 3.9.18-.75 2.33-3.58.5-3.9 1.35v-1.56"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M370.39 382.86c.82-.72 2.72.89 3.9.18-.75 2.33-3.58.5-3.9 1.35z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M372.5 409.54a2.46 2.46 0 0 1-2.15-1c-.61.57-3.15.9-4.15 0a4.09 4.09 0 0 1-3.86.29c-.86.75-3.4.69-4.73-.1a5.66 5.66 0 0 1-2.89 1.07 22.1 22.1 0 0 0-6.37-5.37c-2.25-1.11-6.76-3.26-9.16-4.29-1.39-.61-2.68-1.65 0-.51 2.82 1.22 7.37 3 10.44 4.41 4.4 1.93 22 1.65 24.86 1.39 1.51-.1 3.51-1.24 4.91-2.11 1.07-.65 1.1-.25.07.29a8.05 8.05 0 0 0-3.29 2.32c-1.22 1.69-2.9 2.44-3.55 3.55"
        className="Costa_Rica_svg__cls-144"
      />
      <path
        d="M372.5 409.54a2.46 2.46 0 0 1-2.15-1c-.61.57-3.15.9-4.15 0a4.09 4.09 0 0 1-3.86.29c-.86.75-3.4.69-4.73-.1a5.66 5.66 0 0 1-2.89 1.07 22.1 22.1 0 0 0-6.37-5.37c-2.25-1.11-6.76-3.26-9.16-4.29-1.39-.61-2.68-1.65 0-.51 2.82 1.22 7.37 3 10.44 4.41 4.4 1.93 22 1.65 24.86 1.39 1.51-.1 3.51-1.24 4.91-2.11 1.07-.65 1.1-.25.07.29a8.05 8.05 0 0 0-3.29 2.32c-1.22 1.69-2.9 2.44-3.55 3.55l-.1.06Z"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="m374.14 386.94-5.69-.61a6.47 6.47 0 0 0-.6 5.26c1.82-1.72 5.11-.82 6.76.07-.54-1.51-1.36-3.54-.43-4.68"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m374.14 386.94-5.69-.61a6.47 6.47 0 0 0-.6 5.26c1.82-1.72 5.11-.82 6.76.07-.54-1.51-1.36-3.54-.43-4.68h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M374.57 391.62c-1.68 0-5.69-.06-6.94-.06-1.36 1.75-.61 4.39-.28 5.4 1.5-2.4 6.26-1.12 8.08.6a6.8 6.8 0 0 1-.82-6"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M374.57 391.62c-1.68 0-5.69-.06-6.94-.06-1.36 1.75-.61 4.39-.28 5.4 1.5-2.4 6.26-1.12 8.08.6a6.8 6.8 0 0 1-.82-6h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M375.4 397.64c-1.65-.3-6.94-.65-8-.94a24.2 24.2 0 0 0-1.93 6.34c2.58-2.83 8.55-.75 9.8 2-1.25-2.37-2.5-5.94.18-7.4"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M375.4 397.64c-1.65-.3-6.94-.65-8-.94a24.2 24.2 0 0 0-1.93 6.34c2.58-2.83 8.55-.75 9.8 2-1.25-2.37-2.5-5.94.18-7.4Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m368.31 385.22-7.51-1a9 9 0 0 0-1.75 6c1.57-1.5 7.33-.89 8.8 1.26-.5-2.33-1.15-5.26.5-6.34"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m368.31 385.22-7.51-1a9 9 0 0 0-1.75 6c1.57-1.5 7.33-.89 8.8 1.26-.5-2.33-1.15-5.26.5-6.34h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m367.74 391.73-8.34-1.11c-1.32 1.69-1.25 4.08-.93 6.62 1.9-1.57 8.09-.71 9.55 1.4-.89-3.08-1.64-4.9-.25-6.91"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m367.74 391.73-8.34-1.11c-1.32 1.69-1.25 4.08-.93 6.62 1.9-1.57 8.09-.71 9.55 1.4-.89-3.08-1.64-4.9-.25-6.91Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m368 398.64-8.48-.87a7.31 7.31 0 0 0-1.93 5.8c1.32-2.18 6.94-.6 9.34 1.82-1.43-1.89-1.58-4.61 1.07-6.75"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m368 398.64-8.48-.87a7.31 7.31 0 0 0-1.93 5.8c1.32-2.18 6.94-.6 9.34 1.82-1.43-1.89-1.58-4.61 1.07-6.75"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M354.18 385.22a12.7 12.7 0 0 0-2.58 3.86c1.58-.64 4.91-.82 7 .72-.61-1.18-.82-3.25-.29-4.11a11.4 11.4 0 0 0-4.07-.43"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M354.18 385.22a12.7 12.7 0 0 0-2.58 3.86c1.58-.64 4.91-.82 7 .72-.61-1.18-.82-3.25-.29-4.11a11.4 11.4 0 0 0-4.07-.43h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M350.71 390.23a42 42 0 0 1 8.59 1c-1.15 1.72-1 4.65-.54 6.48-3-2.93-7.87-2.86-10.77-2 .54-1.33 1.86-4.08 2.68-5.55"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M350.71 390.23a42 42 0 0 1 8.59 1c-1.15 1.72-1 4.65-.54 6.48-3-2.93-7.87-2.86-10.77-2 .54-1.33 1.86-4.08 2.68-5.55h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M359.37 398.39a29.2 29.2 0 0 1-10-2.08 31.8 31.8 0 0 0-1.33 7.58c2.4-3.21 8.27-1.43 10.13 1.86-.18-1.75-.83-6 1.18-7.4"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M359.37 398.39a29.2 29.2 0 0 1-10-2.08 31.8 31.8 0 0 0-1.33 7.58c2.4-3.21 8.27-1.43 10.13 1.86-.18-1.75-.83-6 1.18-7.4v0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M354.18 385.22c-5.94 3.58-10.45 10.78-12.13 15.78 1.68 0 3.79.51 4.55 2 1.75-7.2 4.22-13.85 7.58-17.86"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M354.18 385.22c-5.94 3.58-10.45 10.78-12.13 15.78 1.68 0 3.79.51 4.55 2 1.75-7.2 4.22-13.85 7.58-17.86v0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M354.36 381.75c-4.87 4.9-11.77 13.63-14.28 18.39M374.14 386.94c1.33 6.44 1.65 15.09 1.11 18.28"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M381.18 398.57c-1.5.75-4.36-1.35-5.71-.4v-.83c1.31-.92 4.17 1.19 5.71.39v.88"
        className="Costa_Rica_svg__cls-145"
      />
      <path
        d="M381.18 398.57c-1.5.75-4.36-1.35-5.71-.4v-.83c1.31-.92 4.17 1.19 5.71.39z"
        className="Costa_Rica_svg__cls-1"
      />
      <path
        d="M381.18 399.44c-1.5.75-4.36-1.35-5.71-.44v-.87c1.31-.92 4.17 1.19 5.71.4v.87"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M381.18 399.44c-1.5.75-4.36-1.35-5.71-.44v-.87c1.31-.92 4.17 1.19 5.71.4z"
        className="Costa_Rica_svg__cls-146"
      />
      <path
        d="M381.18 400.32c-1.5.79-4.36-1.32-5.71-.4v-.87c1.31-.92 4.17 1.18 5.71.43z"
        className="Costa_Rica_svg__cls-147"
      />
      <path
        d="M381.18 400.32c-1.5.79-4.36-1.32-5.71-.4v-.87c1.31-.92 4.17 1.18 5.71.43z"
        className="Costa_Rica_svg__cls-3"
      />
      <path
        d="M381.18 401.19c-1.5.79-4.36-1.31-5.71-.4v-.87c1.31-.88 4.17 1.19 5.71.4z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M381.18 401.19c-1.5.79-4.36-1.31-5.71-.4v-.87c1.31-.88 4.17 1.19 5.71.4z"
        className="Costa_Rica_svg__cls-146"
      />
      <path
        d="M381.18 402c-1.5.8-4.36-1.31-5.71-.39v-.88c1.31-.91 4.17 1.19 5.71.4z"
        className="Costa_Rica_svg__cls-145"
      />
      <path
        d="M381.18 402c-1.5.8-4.36-1.31-5.71-.39v-.88c1.31-.91 4.17 1.19 5.71.4z"
        className="Costa_Rica_svg__cls-1"
      />
      <path
        d="m357.12 362.61.12-8.49c0-.41.08-.48.09 0v8.61"
        className="Costa_Rica_svg__cls-142"
      />
      <path
        d="m357.12 362.61.12-8.49c0-.41.08-.48.09 0v8.61"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="M357.35 354.1c.29-.25 1 .32 1.38.08-.25.82-1.27.18-1.38.48z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M357.35 354.1c.29-.25 1 .32 1.38.08-.25.82-1.27.18-1.38.48z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m360 362.62.12-8.48c0-.4.08-.48.09 0v8.59"
        className="Costa_Rica_svg__cls-142"
      />
      <path
        d="m360 362.62.12-8.48c0-.4.08-.48.09 0v8.59"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="M360.23 354.13c.29-.26 1 .32 1.38.07-.27.83-1.27.18-1.38.49z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M360.23 354.13c.29-.26 1 .32 1.38.07-.27.83-1.27.18-1.38.49z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m362.7 363.09.13-8.49c0-.41.08-.47.09 0v8.59"
        className="Costa_Rica_svg__cls-142"
      />
      <path
        d="m362.7 363.09.13-8.49c0-.41.08-.47.09 0v8.59"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="M362.93 354.6c.29-.26 1 .32 1.38.06-.26.83-1.26.18-1.38.48v-.55"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M362.93 354.6c.29-.26 1 .32 1.38.06-.26.83-1.26.18-1.38.48v-.55Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M363.68 364.07a.87.87 0 0 1-.76-.37 1.5 1.5 0 0 1-1.47 0 1.44 1.44 0 0 1-1.38.1 1.79 1.79 0 0 1-1.67 0 2.1 2.1 0 0 1-1 .38 7.9 7.9 0 0 0-2.26-1.91c-.8-.39-2.4-1.15-3.25-1.52-.49-.22-.95-.59 0-.18s2.61 1.08 3.71 1.56c1.56.69 7.79.59 8.82.5a4.65 4.65 0 0 0 1.74-.75c.38-.23.39-.09 0 .1a3 3 0 0 0-1.17.83c-.43.59-1 .86-1.25 1.25"
        className="Costa_Rica_svg__cls-144"
      />
      <path
        d="M363.68 364.07a.87.87 0 0 1-.76-.37 1.5 1.5 0 0 1-1.47 0 1.44 1.44 0 0 1-1.38.1 1.79 1.79 0 0 1-1.67 0 2.1 2.1 0 0 1-1 .38 7.9 7.9 0 0 0-2.26-1.91c-.8-.39-2.4-1.15-3.25-1.52-.49-.22-.95-.59 0-.18s2.61 1.08 3.71 1.56c1.56.69 7.79.59 8.82.5a4.65 4.65 0 0 0 1.74-.75c.38-.23.39-.09 0 .1a3 3 0 0 0-1.17.83c-.43.59-1 .86-1.25 1.25h0Z"
        className="Costa_Rica_svg__cls-143"
      />
      <path
        d="m364.26 356.05-2-.22a2.3 2.3 0 0 0-.22 1.87 2.24 2.24 0 0 1 2.4 0c-.19-.53-.48-1.26-.15-1.66"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m364.26 356.05-2-.22a2.3 2.3 0 0 0-.22 1.87 2.24 2.24 0 0 1 2.4 0c-.19-.53-.48-1.26-.15-1.66Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M364.42 357.71h-2.47a2.22 2.22 0 0 0-.1 1.92c.53-.85 2.22-.4 2.87.22a2.42 2.42 0 0 1-.29-2.12"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M364.42 357.71h-2.47a2.22 2.22 0 0 0-.1 1.92c.53-.85 2.22-.4 2.87.22a2.42 2.42 0 0 1-.29-2.12Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M364.71 359.84c-.59-.1-2.46-.23-2.85-.33a8.8 8.8 0 0 0-.68 2.25c.91-1 3-.27 3.48.71-.45-.84-.89-2.11.06-2.63"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M364.71 359.84c-.59-.1-2.46-.23-2.85-.33a8.8 8.8 0 0 0-.68 2.25c.91-1 3-.27 3.48.71-.45-.84-.89-2.11.06-2.63Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m362.19 355.44-2.66-.36a3.2 3.2 0 0 0-.62 2.15 2.8 2.8 0 0 1 3.12.44c-.18-.82-.41-1.86.18-2.25"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m362.19 355.44-2.66-.36a3.2 3.2 0 0 0-.62 2.15 2.8 2.8 0 0 1 3.12.44c-.18-.82-.41-1.86.18-2.25h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m362 357.75-3-.4a3.15 3.15 0 0 0-.33 2.35 3.21 3.21 0 0 1 3.39.5c-.31-1.1-.58-1.74-.09-2.45"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m362 357.75-3-.4a3.15 3.15 0 0 0-.33 2.35 3.21 3.21 0 0 1 3.39.5c-.31-1.1-.58-1.74-.09-2.45Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="m362.08 360.2-3-.31a2.56 2.56 0 0 0-.68 2.06c.47-.78 2.46-.22 3.31.64a1.63 1.63 0 0 1 .38-2.39"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="m362.08 360.2-3-.31a2.56 2.56 0 0 0-.68 2.06c.47-.78 2.46-.22 3.31.64a1.63 1.63 0 0 1 .38-2.39Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M357.18 355.44a4.3 4.3 0 0 0-.91 1.37 2.84 2.84 0 0 1 2.47.25 1.9 1.9 0 0 1-.1-1.46 4 4 0 0 0-1.45-.15"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M357.18 355.44a4.3 4.3 0 0 0-.91 1.37 2.84 2.84 0 0 1 2.47.25 1.9 1.9 0 0 1-.1-1.46 4 4 0 0 0-1.45-.15v0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M356 357.21a15 15 0 0 1 3.05.37 3.22 3.22 0 0 0-.2 2.3 4 4 0 0 0-3.82-.71 21 21 0 0 1 1-2"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M356 357.21a15 15 0 0 1 3.05.37 3.22 3.22 0 0 0-.2 2.3 4 4 0 0 0-3.82-.71 21 21 0 0 1 1-2Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M359 360.11a10.5 10.5 0 0 1-3.54-.74 10.9 10.9 0 0 0-.47 2.69c.85-1.14 2.93-.51 3.59.66-.06-.62-.29-2.14.42-2.62"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M359 360.11a10.5 10.5 0 0 1-3.54-.74 10.9 10.9 0 0 0-.47 2.69c.85-1.14 2.93-.51 3.59.66-.06-.62-.29-2.14.42-2.62Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M357.18 355.44a11.23 11.23 0 0 0-4.3 5.61 1.75 1.75 0 0 1 1.61.71 16.4 16.4 0 0 1 2.69-6.34"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M357.18 355.44a11.23 11.23 0 0 0-4.3 5.61 1.75 1.75 0 0 1 1.61.71 16.4 16.4 0 0 1 2.69-6.34h0Z"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M357.24 354.2a36.4 36.4 0 0 0-5.06 6.53M364.26 356.05a23.6 23.6 0 0 1 .4 6.48"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M366.76 360.17c-.53.27-1.55-.48-2-.14v-.29c.47-.33 1.48.42 2 .14v.31"
        className="Costa_Rica_svg__cls-145"
      />
      <path
        d="M366.76 360.17c-.53.27-1.55-.48-2-.14v-.29c.47-.33 1.48.42 2 .14z"
        className="Costa_Rica_svg__cls-1"
      />
      <path
        d="M366.76 360.48c-.53.27-1.55-.48-2-.15V360c.47-.33 1.48.42 2 .14v.31"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M366.76 360.48c-.53.27-1.55-.48-2-.15V360c.47-.33 1.48.42 2 .14v.31Z"
        className="Costa_Rica_svg__cls-146"
      />
      <path
        d="M366.76 360.79c-.53.28-1.55-.46-2-.14v-.31c.47-.32 1.48.42 2 .16z"
        className="Costa_Rica_svg__cls-147"
      />
      <path
        d="M366.76 360.79c-.53.28-1.55-.46-2-.14v-.31c.47-.32 1.48.42 2 .16z"
        className="Costa_Rica_svg__cls-3"
      />
      <path
        d="M366.76 361.1c-.53.28-1.55-.46-2-.14v-.31c.47-.31 1.48.42 2 .14z"
        className="Costa_Rica_svg__cls-2"
      />
      <path
        d="M366.76 361.1c-.53.28-1.55-.46-2-.14v-.31c.47-.31 1.48.42 2 .14z"
        className="Costa_Rica_svg__cls-146"
      />
      <path
        d="M366.76 361.4c-.53.28-1.55-.47-2-.14V361c.47-.33 1.48.42 2 .14v.29"
        className="Costa_Rica_svg__cls-145"
      />
      <path
        d="M366.76 361.4c-.53.28-1.55-.47-2-.14V361c.47-.33 1.48.42 2 .14v.31Z"
        className="Costa_Rica_svg__cls-1"
      />
      <path
        d="M402.46 334c-4.55 18 .53 29.33 4 37.2 3.29 7.34 3.93 24.4-8.09 36.46C380.56 425.49 367 418.3 360.13 428M358.67 428.06c-6.83-9.73-20.43-2.53-38.28-20.39-12-12.06-11.38-29.12-8.09-36.45 3.51-7.83 8.59-19.21 4.05-37.21"
        className="Costa_Rica_svg__cls-148"
      />
      <path
        d="M361.44 288.83c.25 1.17.57 4.3-1.14 4.75 3.14 3.88 7.7 4.42 15.7 4.42h12c0 1-.33 2.06-.33 3.3s1.26 1.75 3.08 1.34 5.72-1.59 7.83.27c3.55 3.17 10.06 3.72 11.81 5.72-.54-2.42-2.83-4.86-5.37-6.89 2.4-.34 5.51-.1 6.59.72-2.72-3-7.66-3-10.16-4.46a32 32 0 0 0-6.77-3.21 2 2 0 0 0-.82-1.95c-1.57-1.1-4.65-1.48-7.15-1.62a2 2 0 0 0 .43-1.52v-3.88c0-1.35.14-1.69-1.4-2.65-5.94-3.65-13.16-6.26-26.33-6.26s-20.36 2.58-26.33 6.26c-1.57 1-1.39 1.3-1.39 2.65v3.88a1.85 1.85 0 0 0 .43 1.52c-2.51.1-5.55.48-7.16 1.62a2.07 2.07 0 0 0-.82 1.95 29.6 29.6 0 0 0-6.76 3.21c-2.51 1.44-7.44 1.51-10.16 4.46 1-.81 4.15-1.1 6.54-.72-2.5 2-4.79 4.44-5.36 6.89 1.75-2 8.26-2.55 11.84-5.72 2.07-1.85 6-.72 7.83-.27s3.08-.11 3.08-1.34-.32-2.31-.32-3.3c2.93-.07 7 0 12 0 7.94 0 12.48-.56 15.67-4.44-1.76-.45-1.43-3.55-1.15-4.75-3.72-.82-5.58-2.23-8.58-2.23s-3.51 1.57-3.51 2.16v.49c-2.36 0-5.69-.59-6.51-2.14 4.58-1.86 11.38-3.54 20.71-3.54s16.14 1.68 20.72 3.54c-.83 1.55-4.15 2.14-6.51 2.14v-.49c0-.55-.51-2.16-3.51-2.16s-4.87 1.37-8.59 2.23Z"
        className="Costa_Rica_svg__cls-149"
      />
      <path
        d="M330.75 298.08a20.6 20.6 0 0 0-4.87.45c-1.43.45-1.57 1.2-.64 1.62M345.16 289.27v1.8a3.07 3.07 0 0 0 3.19 2.68c4.75 0 5.68-.82 9.23-.73"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M357.54 292.93c-3.29-.56-5.9-2.31-8.8-2.31s-3.47 1.3-3 1.93M324 294.92v3.54c0 1 .68 2.31 3.26 1.79 2.25-.41 3.72.1 3.72 1.07"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M332 291.31c.54.54 1.72 1 4.33 2 4.8 1.75 15.81 3 23-.18M380.11 287.11c.93.38 1.79.75 2.54 1.13 4.48 2.24 4.8 2.76 3.22 3.61M388 298.08a20.6 20.6 0 0 1 4.87.45c1.43.45 1.57 1.2.64 1.62M373.57 289.27v1.8a3.07 3.07 0 0 1-3.19 2.68c-4.75 0-5.68-.82-9.23-.73"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M361.19 292.93c3.29-.56 5.9-2.31 8.8-2.31s3.47 1.3 2.94 1.93M394.71 294.92v3.54c0 1-.68 2.31-3.26 1.79-2.25-.41-3.72.1-3.72 1.07"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M386.7 291.31c-.54.54-1.72 1-4.33 2-4.79 1.75-15.81 3-23-.18"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M359.36 293.75c2.19 0 2.26-1.65 2.26-3.16s-.07-3.14-2.26-3.14-2.25 1.66-2.25 3.14.07 3.16 2.25 3.16"
        className="Costa_Rica_svg__cls-149"
      />
      <path
        d="M338.78 287.11c-1 .38-1.84.76-2.61 1.13-4.57 2.24-4.9 2.76-3.29 3.61"
        className="Costa_Rica_svg__cls-6"
      />
      <g id="Costa_Rica_svg__l">
        <path
          d="M354.14 317c3-1.93 6.73-5.18 8.09-7.33 1.86-3 2.11-1.54 3.54-1.79a74.6 74.6 0 0 1-10.52 9.7l-1.11-.58M329 324.21c-7.51-4.26-10.37.18-12.13.39 2.07.51 3.82 3.83 12.13-.39Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M332.36 321.75c-7.16-4.84-10.34-.62-12.13-.51 2.04.64 3.54 4.11 12.13.51Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M337.47 318.88c-7.05-5-10.34-.83-12.13-.75 2.04.71 3.44 4.15 12.13.75Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M341.69 316.34c-6.47-5.72-10.19-1.93-11.95-2.08 1.94.94 2.97 4.51 11.95 2.08Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M347.09 314.48c-6.18-6.05-10.08-2.43-11.84-2.68 1.9 1 2.75 4.68 11.84 2.68Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M352.75 313.87c-5.12-6.94-9.55-4-11.27-4.54 1.68 1.33 1.93 5.04 11.27 4.54Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M353.68 314.15c-.25-1.56-3.19-3.57-3.44-4.32a.8.8 0 0 0 .54-1.29c-.25-.25-.86-.11-1.18.22a1.42 1.42 0 0 0 .39 2.11 9.4 9.4 0 0 1 2.87 3.28"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M322.16 324.71c2-.61 4.61-.32 6.4-.5M325.49 321.71c2.11-.47 4.61 0 6.44 0M330.6 318.7c2.11-.39 4.62.11 6.44.11M334.89 315.41c2.15-.17 4.58.61 6.37.82M340.33 313.19c2.15-.07 4.55.83 6.33 1.15M346.31 311.54c2.14.22 4.36 1.58 6 2.12"
          className="Costa_Rica_svg__cls-150"
        />
      </g>
      <g id="Costa_Rica_svg__l-2" data-name="l">
        <path
          d="M364.62 317c-3-1.93-6.72-5.18-8.08-7.33-1.86-3-2.11-1.54-3.54-1.79a75 75 0 0 0 10.51 9.7l1.11-.58M389.77 324.21c7.52-4.26 10.38.18 12.13.39-2.07.51-3.83 3.83-12.13-.39Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M386.41 321.75c7.16-4.84 10.34-.62 12.13-.51-2.04.64-3.54 4.11-12.13.51Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M381.3 318.88c7-5 10.33-.83 12.12-.75-2.04.71-3.42 4.15-12.12.75Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M377.07 316.34c6.48-5.72 10.2-1.93 11.95-2.08-1.93.94-2.97 4.51-11.95 2.08Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M371.67 314.48c6.19-6.05 10.09-2.43 11.84-2.68-1.89 1-2.75 4.68-11.84 2.68Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M366 313.87c5.11-6.94 9.55-4 11.27-4.54-1.66 1.33-1.91 5.04-11.27 4.54Z"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M365.09 314.15c.25-1.56 3.18-3.57 3.43-4.32a.8.8 0 0 1-.53-1.29c.25-.25.86-.11 1.18.22a1.41 1.41 0 0 1-.4 2.11 9.5 9.5 0 0 0-2.86 3.28"
          className="Costa_Rica_svg__cls-141"
        />
        <path
          d="M396.61 324.71c-2-.61-4.62-.32-6.41-.5M393.28 321.71c-2.11-.47-4.62 0-6.44 0M388.16 318.7c-2.11-.39-4.61.11-6.44.11M383.87 315.41c-2.15-.17-4.58.61-6.37.82M378.43 313.19c-2.14-.07-4.54.83-6.33 1.15M372.46 311.54c-2.15.22-4.37 1.58-6 2.12"
          className="Costa_Rica_svg__cls-150"
        />
      </g>
      <path
        d="M359.4 316.6a35 35 0 0 0 4.15-.14v-2.4c0-.79 2.79-1.72 7-.9 16.53 3.23 18.79 10.7 31.34 15 .15 0 .61.18 1.15.28.32-.75.68-1.5 1.07-2.43.22-.68 2-.65 3.65.1 1.86.9 2.68 1.94 2.36 2.48-.32.78-.64 1.42-.93 2.07 2.94 1 8.27 2.62 6.51 9.66a12.07 12.07 0 0 0-6.69-2.76c-2.32 0-4.83-.89-4-3.43a8.7 8.7 0 0 0-1.57-.68 4 4 0 0 1-.29.64c-.54 1.33-2.86 1.8-5.19 1-13.09-4.47-17.13-14.35-32.59-14.49v.4c0 1.25-1.61 2.39-5.94 2.39s-5.93-1.14-5.93-2.39v-.43c-15.42.1-19.5 10-32.6 14.49-2.28.79-4.61.28-5.18-1a5 5 0 0 0-.29-.64 8.7 8.7 0 0 0-1.57.68c.75 2.51-1.69 3.43-4.05 3.43a12.23 12.23 0 0 0-6.69 2.76c-1.75-7 3.51-8.58 6.52-9.66-.29-.65-.58-1.29-.94-2.07-.28-.54.51-1.58 2.37-2.48 1.61-.78 3.39-.82 3.65-.1.39.89.71 1.64 1.07 2.43.54-.1 1-.25 1.14-.28 12.52-4.3 14.81-11.77 31.34-15 4.19-.82 7 .11 7 .9v2.4c1 .1 2.47.14 4.15.14Z"
        className="Costa_Rica_svg__cls-151"
      />
      <path
        d="M355.22 316.46c-1.11-.11-1.75-.36-1.75-.79 0-1.07 1.75-.71 1.75-1.61M313.11 328.23c.64 1.54 1.47 3.51 2.22 5.18M311.54 329c.64 1.5 1.86 4.07 2.21 5.14"
        className="Costa_Rica_svg__cls-151"
      />
      <path
        d="M308.57 328.62c.43.75 2.68-.36 3 .36s-.43 1.14-2 1.71M314.61 326c.32 1-1.93 1.36-1.46 2.22.28.57 1.53.39 2.54.17"
        className="Costa_Rica_svg__cls-6"
      />
      <path
        d="M353.43 315.64v5M363.59 316.46c1.07-.11 1.75-.36 1.75-.79 0-1.07-1.75-.71-1.75-1.61M405.7 328.23c-.65 1.54-1.47 3.51-2.22 5.18M407.27 329c-.65 1.5-1.86 4.07-2.22 5.14"
        className="Costa_Rica_svg__cls-151"
      />
      <path
        d="M410.24 328.62c-.43.75-2.68-.36-3 .36s.43 1.14 2 1.71M404.19 326c-.32 1 1.94 1.36 1.47 2.22-.29.57-1.54.39-2.54.17"
        className="Costa_Rica_svg__cls-6"
      />
      <path d="M365.38 315.64v5" className="Costa_Rica_svg__cls-151" />
      <path d="m320.24 333.42-1.39-4.95 1.73-.48a2.3 2.3 0 0 1 1-.13 1 1 0 0 1 .6.33 1.6 1.6 0 0 1 .4.74 1.5 1.5 0 0 1 0 1 1.32 1.32 0 0 1-.67.67 1.9 1.9 0 0 1 .55.29 6 6 0 0 1 .7.67l.76.83-1 .28-.89-.92c-.33-.33-.54-.53-.64-.61a.8.8 0 0 0-.3-.13 1.3 1.3 0 0 0-.43.06l-.17.05.58 2.07Zm0-3.08.61-.17a3.4 3.4 0 0 0 .69-.25.45.45 0 0 0 .19-.27.76.76 0 0 0 0-.42.7.7 0 0 0-.2-.35.54.54 0 0 0-.32-.13 4 4 0 0 0-.67.15l-.64.18ZM324.79 332.09l-2.28-4.61 2.8-1.39.39.78-2 1 .5 1 1.9-.94.39.77-1.9.95.62 1.25 2.11-1.05.39.78ZM328.5 330.13l-2.78-4.32 1.15-.74a3.9 3.9 0 0 1 .88-.48 1.1 1.1 0 0 1 .79.09 1.86 1.86 0 0 1 .75.71 2 2 0 0 1 .33.9 1.22 1.22 0 0 1-.15.73 2.9 2.9 0 0 1-.83.72l-.47.3 1.05 1.63Zm-1.6-4.05.79 1.23.4-.26a2 2 0 0 0 .5-.4.6.6 0 0 0 .11-.35.8.8 0 0 0-.14-.42.72.72 0 0 0-.33-.3.52.52 0 0 0-.36-.05 2.7 2.7 0 0 0-.62.33ZM328.82 323.84l.7-.48 1.6 2.28a5 5 0 0 0 .51.67.82.82 0 0 0 .52.28.77.77 0 0 0 .56-.17.8.8 0 0 0 .29-.42.66.66 0 0 0 0-.44 4 4 0 0 0-.52-.86l-1.63-2.34.7-.49 1.55 2.22a7.5 7.5 0 0 1 .77 1.29 1.32 1.32 0 0 1 0 .9 1.73 1.73 0 0 1-.68.82 1.87 1.87 0 0 1-1 .39 1.25 1.25 0 0 1-.82-.24 5.1 5.1 0 0 1-1-1.2ZM332.38 321.27l1.42-.91a2.5 2.5 0 0 1 .88-.42 1.1 1.1 0 0 1 .64.12 1.46 1.46 0 0 1 .78 1.16 1.2 1.2 0 0 1-.12.6 1.1 1.1 0 0 1 .74.07 1.3 1.3 0 0 1 .6.54 1.6 1.6 0 0 1 .29.95 1.1 1.1 0 0 1-.28.75 7 7 0 0 1-1 .69l-1.21.78Zm1.17.26.65 1 .47-.3c.28-.18.45-.3.51-.35a.5.5 0 0 0 .19-.34.6.6 0 0 0-.11-.41.7.7 0 0 0-.29-.26.4.4 0 0 0-.3 0 4 4 0 0 0-.7.41Zm1.11 1.72.74 1.16.67-.43a2.3 2.3 0 0 0 .53-.4.55.55 0 0 0 .09-.32.83.83 0 0 0-.45-.68.5.5 0 0 0-.36 0 2.7 2.7 0 0 0-.64.34ZM338.45 323.36l-2.35-4.53.75-.39 2 3.76 1.88-1 .4.77ZM341.64 321.64l-2-4.75.78-.32 2 4.74ZM345 318.57l.89.07a2.33 2.33 0 0 1-.26 1.39 1.6 1.6 0 0 1-.94.7 1.67 1.67 0 0 1-1.47-.23 3.08 3.08 0 0 1-1.13-1.73 3.2 3.2 0 0 1 0-2.14 1.71 1.71 0 0 1 1.14-1 1.63 1.63 0 0 1 1.28.13 2.1 2.1 0 0 1 .77.83l-.74.48a1.13 1.13 0 0 0-.49-.52.8.8 0 0 0-.61 0 .89.89 0 0 0-.61.61 2.33 2.33 0 0 0 .1 1.37 2.55 2.55 0 0 0 .67 1.24.88.88 0 0 0 .84.18.76.76 0 0 0 .48-.42 1.6 1.6 0 0 0 .1-.89ZM350.59 319.19l-.91.17-.58-1.08-1.66.31-.12 1.22-.89.16.66-5.36.89-.16Zm-1.92-1.71-.92-1.77-.21 2ZM355.87 317.24l1.51.11a2.3 2.3 0 0 1 .86.2 1.6 1.6 0 0 1 .5.47 2.3 2.3 0 0 1 .33.82 4.2 4.2 0 0 1 0 1.21 3.8 3.8 0 0 1-.23 1.12 2.1 2.1 0 0 1-.43.73 1.3 1.3 0 0 1-.57.38 2 2 0 0 1-.84.08l-1.55-.12Zm.76.91-.25 3.31.62.05a1.6 1.6 0 0 0 .58 0 .67.67 0 0 0 .31-.2 1.4 1.4 0 0 0 .23-.47 4 4 0 0 0 .14-.86 3.6 3.6 0 0 0 0-.88 1.07 1.07 0 0 0-.2-.52.7.7 0 0 0-.38-.28 2.8 2.8 0 0 0-.67-.09ZM360.19 322.5l-.32-5 3.05-.19.06.84-2.22.14.07 1.11 2.06-.13.05.85-2.06.13.09 1.36 2.29-.14.06.84ZM369.48 317.7l.81.37a2.36 2.36 0 0 1-.71 1.22 1.62 1.62 0 0 1-1.13.34 1.65 1.65 0 0 1-1.3-.7 3.08 3.08 0 0 1-.48-2 3.2 3.2 0 0 1 .7-2 1.68 1.68 0 0 1 1.42-.57 1.6 1.6 0 0 1 1.15.55 2 2 0 0 1 .45 1l-.86.2a1.06 1.06 0 0 0-.28-.65.8.8 0 0 0-.56-.25.89.89 0 0 0-.78.36 2.35 2.35 0 0 0-.36 1.33 2.45 2.45 0 0 0 .21 1.4.87.87 0 0 0 .73.44.72.72 0 0 0 .59-.23 1.6 1.6 0 0 0 .4-.81M371.38 317.24a3.55 3.55 0 0 1 .62-1.41 2.06 2.06 0 0 1 .9-.69 1.9 1.9 0 0 1 1.11 0 1.84 1.84 0 0 1 1.26 1 3 3 0 0 1 .09 2 3.1 3.1 0 0 1-1.07 1.82 1.95 1.95 0 0 1-2.8-.68 3 3 0 0 1-.11-2.08Zm.86.17a2.2 2.2 0 0 0 0 1.38 1 1 0 0 0 .71.63 1 1 0 0 0 .91-.23 2.26 2.26 0 0 0 .65-1.24 2.2 2.2 0 0 0 0-1.36 1 1 0 0 0-.71-.61 1 1 0 0 0-.93.21 2.22 2.22 0 0 0-.63 1.22M375.82 319.33l.8.23c-.17.64 0 1.07.46 1.27a.86.86 0 0 0 .64.05.67.67 0 0 0 .4-.37.6.6 0 0 0 .05-.31.7.7 0 0 0-.14-.28 8 8 0 0 0-.6-.54 2.8 2.8 0 0 1-.6-.64 1.4 1.4 0 0 1-.17-.62 1.45 1.45 0 0 1 .13-.68 1.6 1.6 0 0 1 .47-.63 1.33 1.33 0 0 1 .69-.26 1.8 1.8 0 0 1 .83.17 1.6 1.6 0 0 1 .91.82 1.63 1.63 0 0 1 0 1.24l-.81-.29a.9.9 0 0 0 0-.63.8.8 0 0 0-.43-.36.83.83 0 0 0-.54-.07.42.42 0 0 0-.31.25.47.47 0 0 0 0 .4 2.5 2.5 0 0 0 .6.59 3.5 3.5 0 0 1 .7.72 1.4 1.4 0 0 1 .19.66 1.8 1.8 0 0 1-.17.78 1.55 1.55 0 0 1-.82.88 1.7 1.7 0 0 1-1.36-.08 1.65 1.65 0 0 1-.9-2.3ZM379.78 323l2.08-3.74-1.09-.61.42-.76 2.93 1.64-.42.76-1.09-.61-2.09 3.73ZM385.26 326.43l-.77-.51.33-1.18-1.41-.92-.93.79-.75-.5 4.19-3.4.75.49Zm-.19-2.56.56-1.92-1.52 1.29ZM387 327.66l2.94-4.23 1.47 1a2.4 2.4 0 0 1 .73.67 1.05 1.05 0 0 1 .12.67 1.7 1.7 0 0 1-.31.78 1.53 1.53 0 0 1-.79.64 1.3 1.3 0 0 1-.94-.09 2.3 2.3 0 0 1 .12.61 6 6 0 0 1-.07 1l-.16 1.12-.83-.58.13-1.27a6 6 0 0 0 .06-.88.6.6 0 0 0-.08-.32 1.2 1.2 0 0 0-.32-.29l-.15-.1-1.22 1.76Zm2.39-2 .52.37a2.8 2.8 0 0 0 .64.37.4.4 0 0 0 .32 0 .76.76 0 0 0 .32-.28.7.7 0 0 0 .14-.38.46.46 0 0 0-.1-.32 3.2 3.2 0 0 0-.54-.43l-.55-.38ZM390.44 330.06l2.83-4.3.71.47-2.83 4.29ZM395.1 330.7l.56.69a2.3 2.3 0 0 1-1.19.77 1.54 1.54 0 0 1-1.15-.2 1.64 1.64 0 0 1-.85-1.21 3.1 3.1 0 0 1 .47-2 3.27 3.27 0 0 1 1.54-1.49 1.68 1.68 0 0 1 1.52.13 1.57 1.57 0 0 1 .79 1 2 2 0 0 1-.07 1.13l-.85-.2a1.2 1.2 0 0 0 0-.72.8.8 0 0 0-.39-.47.88.88 0 0 0-.86 0 2.4 2.4 0 0 0-.92 1 2.5 2.5 0 0 0-.44 1.35.86.86 0 0 0 .45.72.76.76 0 0 0 .63.07 1.7 1.7 0 0 0 .72-.55ZM399.09 334.43l-.87-.32.06-1.23-1.57-.59-.74 1-.85-.32 3.34-4.24.85.31Zm-.76-2.45.13-2-1.21 1.58ZM339.29 285.83l-.71.32-.69-.77-1.3.59.14 1-.7.31-.52-4.54.69-.31Zm-1.91-1-1.12-1.27.23 1.67ZM339.65 285.72l-1.36-4.14 1-.33 1.55 2.61-.32-3 1-.34 1.37 4.14-.64.21-1.07-3.26.4 3.48-.66.22-1.74-3 1.07 3.26ZM343.63 284.46l-1-4.23 2.57-.63.17.71-1.87.47.23.93 1.74-.43.18.72-1.74.43.28 1.15 1.94-.48.17.71ZM346.86 283.68l-.77-4.28 1.49-.27a2 2 0 0 1 .84 0 1 1 0 0 1 .48.33 1.4 1.4 0 0 1 .28.65 1.24 1.24 0 0 1-.1.85 1 1 0 0 1-.61.51 1.8 1.8 0 0 1 .44.29 5 5 0 0 1 .53.63l.58.75-.85.16-.68-.84a6 6 0 0 0-.49-.57.5.5 0 0 0-.24-.13.9.9 0 0 0-.37 0h-.14l.32 1.79Zm.26-2.6.53-.09a3.4 3.4 0 0 0 .61-.15.46.46 0 0 0 .18-.21.7.7 0 0 0 0-.36.6.6 0 0 0-.14-.31.38.38 0 0 0-.26-.13 2.6 2.6 0 0 0-.58.07l-.55.1ZM350.39 283.09l-.59-4.31.71-.1.59 4.31ZM353.91 281.08l.72.2a1.9 1.9 0 0 1-.44 1.11 1.37 1.37 0 0 1-.9.43 1.41 1.41 0 0 1-1.18-.43 2.56 2.56 0 0 1-.65-1.62 2.74 2.74 0 0 1 .33-1.78 1.44 1.44 0 0 1 1.12-.66 1.36 1.36 0 0 1 1 .32 1.75 1.75 0 0 1 .51.82l-.69.27a1 1 0 0 0-.33-.51.66.66 0 0 0-.49-.14.76.76 0 0 0-.61.4 2 2 0 0 0-.14 1.16 2.15 2.15 0 0 0 .35 1.14.75.75 0 0 0 .67.28.66.66 0 0 0 .47-.26 1.46 1.46 0 0 0 .26-.73M358.59 282.44h-.79l-.35-1-1.42.06-.26 1h-.76l1.21-4.4h.76Zm-1.4-1.67-.55-1.59-.42 1.63ZM362.7 280.92l.68.3a2 2 0 0 1-.57 1 1.42 1.42 0 0 1-.95.3 1.36 1.36 0 0 1-1.11-.57 2.62 2.62 0 0 1-.45-1.69 2.8 2.8 0 0 1 .56-1.73 1.47 1.47 0 0 1 1.2-.51 1.4 1.4 0 0 1 1 .45 1.76 1.76 0 0 1 .4.88l-.72.18a.92.92 0 0 0-.26-.55.68.68 0 0 0-.47-.21.74.74 0 0 0-.65.33 1.93 1.93 0 0 0-.29 1.12 2.15 2.15 0 0 0 .2 1.18.74.74 0 0 0 .62.37.64.64 0 0 0 .5-.2 1.47 1.47 0 0 0 .33-.7ZM364 282.59l.37-4.34 2.64.23-.06.74-1.93-.17-.08 1 1.79.16-.07.73-1.78-.16-.1 1.18 2 .17-.06.73ZM367.27 282.89l.62-4.31.69.1 1 3.09.41-2.88.66.09-.61 4.31-.72-.1-1-3-.4 2.81ZM371.61 283.59l.71-3.55-1-.21.15-.72 2.78.56-.15.72-1-.21-.71 3.55ZM373.82 284l1.11-4.21 1.47.39a2.1 2.1 0 0 1 .77.33.86.86 0 0 1 .29.49 1.37 1.37 0 0 1 0 .72 1.3 1.3 0 0 1-.45.73 1.1 1.1 0 0 1-.77.2 2.2 2.2 0 0 1 .28.45 7 7 0 0 1 .22.79l.2.93-.83-.22-.26-1.05q-.15-.57-.21-.72a.55.55 0 0 0-.16-.22.84.84 0 0 0-.34-.14H375l-.47 1.75Zm1.33-2.24.52.13a2.2 2.2 0 0 0 .62.12.38.38 0 0 0 .25-.11.74.74 0 0 0 .17-.32.56.56 0 0 0 0-.34.44.44 0 0 0-.17-.23 2.7 2.7 0 0 0-.56-.18l-.54-.14ZM380.33 286l-.74-.26v-1l-1.35-.47-.6.84-.72-.25 2.73-3.66.72.25Zm-.69-2.06.06-1.69-1 1.37ZM380.7 286.19l1.74-4 .65.29-1.44 3.28 1.65.72-.3.68Z" />
    </g>
  </svg>
);
export default SvgCostaRica;
